module.exports = __webpack_public_path__ + "img/9f80f03b-7b56-40ef-8d20-dd8a2589ff92.fd2cea97.webp";